import React from "react";
import Styles from './styles.module.scss';
import { useTranslation } from "react-i18next";
import {useNavigate} from "react-router-dom";


const AboutS7 = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <section className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.contentBox}`}>
                    <div className={`${Styles.noteWrap}`}>
                        <div className={`${Styles.noteItem}`}>{t('Станьте частью лучшей экосистемы,')}</div>
                        <div className={`${Styles.noteItem}`}>{t('которая создаёт возможности для роста!')}</div>
                    </div>
                    <div className={`${Styles.aboutBtn}`} onClick={() => navigate('/sign-up')}>{t('Начать работу')}</div>
                </div>
            </div>
        </section>
    );
};

export default AboutS7;




